module.exports = __webpack_public_path__ + "a90b1fdd56faba72ebbd77827d40a15b.svg";